module.exports = __webpack_public_path__ + "img/graduate-1981-graduates.801d8891.jpg";